<template>
  <open-banking-description-step class="obk-description-canceled-cards-note-step" :step-number="stepNumber">
    <template v-slot:text>
      <div>כרגע לא ניתן לחבר כרטיסים מבוטלים.</div>
    </template>
  </open-banking-description-step>
</template>

<script>
import OpenBankingDescriptionStep from '@/base-components/onboarding/openBanking/OpenBankingDescriptionStep';

export default {
  name: 'ObkDescriptionCanceledCardsNoteStep',
  components: {
    OpenBankingDescriptionStep,
  },
  props: {
    stepNumber: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
